// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"9fc1e932","703":"cf5753f3","787":"a5908871"}[chunkId] + ".chunk.js";
};